export default "$ yarn add font-awesome@4.7.0 -D\n// OR\n$ npm install font-awesome@4.7.0 -D\n";